import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { unixToDate, cleanObject, removeTitleCase } from 'src/utils/core';
import SmartTable from '../../components/smart-table/SmartTable';
import { updateColumnPreferences } from 'src/features/tableActions/userColPreferenceApi';
import { logoutUser, updateUserPreferences } from 'src/features/user/userState';
import { useAppSelector, useAppDispatch } from 'src/hooks/hooks';
import { getUserInfo } from 'src/features/user/userState';
import { incrementAwaitingApiCounter, decrementAwaitingApiCounter } from 'src/features/ui/uiState';
import { dualShipmentOverlapReport } from 'src/features/replacementOrder/replacementApi';
import { Container, Box, Typography, TextField, Button, Stack, Grid, Divider } from '@mui/material';
import MultipleSelect from 'src/components/select/MultipleSelect';
import DateRangePicker from 'src/components/date-picker/DateRangePicker';
import { getConfig, getConfigData } from 'src/features/config/configState';
import MultiSelectInput from 'src/components/select/MulltiSelect';
import InputForm from 'src/components/input-field/InputField';
import Iconify from 'src/components/iconify';


export default function DualShipment() {

	const [isAdvancedFilterOpen, setIsAdvancedFilterOpen] = useState(false);
	const [rows, setRows] = useState([]);
	const [totalItemsCount, setTotalItemCount] = useState(0);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [showLoader, setShowLoader] = useState(false);
	const [startDate, setStartDate] = useState(dayjs().subtract(10, 'day').format('MM/DD/YYYY'));
	const [endDate, setEndDate] = useState(dayjs().format('MM/DD/YYYY'));
	const userInfo = useAppSelector(getUserInfo);
	const dispatch = useAppDispatch();
	const trackingInfo = useAppSelector((state) => state.user.trackingInfo);
	const mailScan = useAppSelector((state) => state.user.mailScan);
	const replacementColumns = useAppSelector((state) => state.user.replacementColumns);
	const dualShipmentColumns = useAppSelector((state) => state.user.dualShipmentColumns);
	const [userSelectedColumns, setUserSelectedColumns] = useState(dualShipmentColumns || []);
	const [rawColumnList, setRawColumnList] = useState([]);
	const [order, setSortOrder] = useState('asc');
	const [field, setSortField] = useState('first_name');
	const [parentStatus, setParentStatus] = useState([]);
	const [replaceStatus, setReplaceStatus] = useState([]);

	const [parentOrderNo, setParentOrderNo] = useState('');
	const [replaceOrderNo, setReplaceOrderNo] = useState('');

	const token = userInfo?.accessToken;

	useEffect(() => {
		dispatch(getConfig(userInfo?.accessToken));
	}, []);

	const configData = useAppSelector(getConfigData);



	const defaultColumn = 'parent_order_no';

	const fetchTableData = async ({ startDate, endDate, page_size = 10, current_page = 0, order = 'desc', field = 'replace_order_created_date', parentOrderStatus = [], replaceOrderStatus = [], parentOrderNo = '', replaceOrderNo = '' }, appendRow = false) => {
		dispatch(incrementAwaitingApiCounter());
		setShowLoader(true);
		try {
			let queryParams = {
				dateRange: `${startDate}-${endDate}`,
				page_size,
				current_page,
				sortOrder: order == 'desc' ? -1 : 1,
				sortField: field,
				parent_order_status: parentOrderStatus,
				replace_order_status: replaceOrderStatus,
				parent_order_no: parentOrderNo,
				replace_order_no: replaceOrderNo,
			};
			const response = await dualShipmentOverlapReport(cleanObject(queryParams), token);
			if (response.rows && response.rows.length) {
				response.rows.forEach((row) => {
					row.parent_shipped_on = unixToDate(row.parent_shipped_on);
					row.replace_created_on = unixToDate(row.replace_created_on);
					row.parent_transit_date = unixToDate(row.parent_transit_date);
				});
			}
			if (appendRow && rows.length > 0) {
				setRows([...new Set(rows), ...response.rows]);
			} else {
				setRows(response.rows);
			}
			setTotalItemCount(response.total_count);
			dispatch(decrementAwaitingApiCounter());
			setShowLoader(false);
		} catch (error) {
			console.error('Error fetching data:', error);
			dispatch(decrementAwaitingApiCounter());
			setShowLoader(false);
		}
	};

	useEffect(() => {
		fetchTableData({ startDate, endDate, order, field });
	}, [startDate, endDate, order, field])

	const handleColumnSubmit = (columnList) => {
		setUserSelectedColumns(columnList.map((item) => removeTitleCase(item)));
		dispatch(
			updateUserPreferences({
				dualShipmentColumns: columnList.map((item) => removeTitleCase(item)),
				replacementColumns: replacementColumns,
				mailScan: mailScan,
				trackingInfo: trackingInfo,
			})
		);
		updateColumnPreferences(
			{ table_name: 'dual_shipment_columns', table_columns: columnList.map((item) => removeTitleCase(item)) },
			userInfo?.accessToken
		);
	};

	// pagination
	const handleChangePage = (event, newPage) => {
		setPage(newPage);
		if (newPage <= page || rows.length > rowsPerPage * (Number(page) + 1)) {
			return;
		}
		fetchTableData({ startDate, endDate, page_size: rowsPerPage, current_page: newPage + 1, order, field }, true);
	};

	const handleChangeRowsPerPage = (event) => {
		setPage(0);
		setRowsPerPage(parseInt(event.target.value) || 10);
		fetchTableData({ startDate, endDate, page_size: parseInt(event.target.value) || 10, current_page: page, order, field });
	};


	const onExpandhandler = (event, trackNumber, index) => {
		event.preventDefault();
		if (index == 'customer_id') {
			window.open(`${configData?.magento?.customer_account_url}${trackNumber}`, '_blank');
		}
	};


	const statusSelect = [
		{
			label: 'Alert',
			value: 'Alert',
		},
		{
			label: 'Available for Agent Pickup',
			value: 'Available for Agent Pickup',
		},
		{
			label: 'Available for Pickup',
			value: 'Available for Pickup',
		},
		{
			label: 'Delivered',
			value: 'Delivered',
		},
		{
			label: 'Delivered to Agent',
			value: 'Delivered to Agent',
		},
		{
			label: 'Delivery Attempt',
			value: 'Delivery Attempt',
		},
		{
			label: 'Forwarded',
			value: 'Forwarded',
		},
		{
			label: 'In Transit',
			value: 'In Transit',
		},
		{
			label: 'Out for Delivery',
			value: 'Out for Delivery',
		},
		{
			label: 'Pre-Shipment',
			value: 'Pre-Shipment',
		},
		{
			label: 'Returned',
			value: 'Returned',
		},
		{
			label: 'Unknown',
			value: 'Unknown',
		},
	];

	const FilteredRows = rows?.map(
		({
			customer_id,
			first_name,
			last_name,
			customer_email,
			shipping_street,
			shipping_city,
			shipping_state,
			shipping_country,
			shipping_postal_code,
			shipping_telephone,
			parent_order_no,
			carrier,
			parent_shipped_on,
			parent_track_no,
			parent_latest_category,
			replace_order_no,
			replace_created_on,
			replace_track_no,
			replace_latest_category,
			replace_to_parent_scan_duration: scan_duration,
			parent_transit_date
		}) => ({
			customer_id,
			customer_email,
			shipping_street,
			shipping_city,
			shipping_state,
			shipping_country,
			shipping_postal_code,
			shipping_telephone,
			first_name,
			last_name,
			carrier,
			parent_order_no,
			parent_track_no,
			parent_latest_category,
			parent_shipped_on,
			parent_transit_date,
			replace_created_on,
			replace_order_no,
			replace_track_no,
			replace_latest_category,
			scan_duration
		})
	);

	const getDateRange = (dates) => {
		if (dates != null && dates.length > 0) {
			const formattedStartDate = dayjs(dates[0]).format('MM/DD/YYYY');
			const formattedEndDate = dayjs(dates[1]).format('MM/DD/YYYY');
			fetchTableData({ startDate: formattedStartDate, endDate: formattedEndDate, page_size: rowsPerPage, current_page: 1 });
			setStartDate(formattedStartDate);
			setEndDate(formattedEndDate);
			setPage(0);
		}
	};

	// Handler for MultiSelectInput (status)
	const handleParentStatusChange = (event) => {
		const selectedValues = event.target.value; // Array of selected status values
		setParentStatus(selectedValues);
	};

	const handleReplaceStatusChange = (event) => {
		const selectedValues = event.target.value; // Array of selected status values
		setReplaceStatus(selectedValues);
	};

	// Handler for Parent Order No Input
	const handleParentOrderChange = (event) => {
		const value = event.target.value;
		setParentOrderNo(value);
	};

	// Handler for Parent Order No Input
	const handleReplaceOrderChange = (event) => {
		const value = event.target.value;
		setReplaceOrderNo(value);
	};


	const handleContinue = () => {
		setShowLoader(true);
		const filterParams = {
			startDate,
			endDate,
			page_size: rowsPerPage,
			current_page: 0,
			parentOrderStatus: parentStatus,
			replaceOrderStatus: replaceStatus,
			parentOrderNo,
			replaceOrderNo,
		};
		fetchTableData(filterParams);
	};



	useEffect(() => {
		if (FilteredRows.length > 0) {
			setRawColumnList(Object.keys(FilteredRows[0]));
		}
	}, [rows]);

	const sortOrder = (columnName, sortOrder) => {
		setSortOrder(sortOrder);
		setSortField(columnName);
	};

	return (
		<>
			<Helmet>
				<title> Dual Shipment | Shipping Insights </title>
			</Helmet>
			<Container maxWidth="xl">
				<Stack direction="row" justifyContent="space-between">
					<Grid item xs="auto" sx={{ marginRight: { xl: '120px', lg: '10px' } }}>
						<MultipleSelect
							columnsDetails={rawColumnList}
							selectedColumns={userSelectedColumns}
							handleColumnSubmit={handleColumnSubmit}
							sx={{ marginLeft: 0 }}
						/>
					</Grid>


					<Grid item xs="auto" sx={{ marginRight: { xl: '120px', lg: '10px' } }}>
						<Button
							variant="contained"
							className={isAdvancedFilterOpen && 'btn-active'}
							onClick={() => setIsAdvancedFilterOpen(!isAdvancedFilterOpen)}
							type="button"
							sx={{
								boxShadow: 'none',
								color: 'primary.light',
								width: { md: 184, sm: 148 },
								height: { lg: 40, sm: 33 },
								fontFamily: 'Whitney',
								letterSpacing: '0.15px',
								lineHeight: '24px',
								fontSize: { sm: 13, lg: 16 },
								backgroundColor: 'common.white',
								'&.btn-active, :hover': {
									color: 'common.white',
									backgroundColor: 'primary.light',
								},
							}}
							startIcon={<Iconify icon="material-symbols:instant-mix" />}
						>
							Advanced Filter
						</Button>
					</Grid>

					<DateRangePicker
						label='Label Date'
						startDate={startDate}
						endDate={endDate}
						sx={{ marginBottom: 2 }}
						onDateChange={getDateRange}
					/>
				</Stack>

				{/* Advanced Filter Section */}
				{isAdvancedFilterOpen && (
					<Box
						sx={{
							display: 'flex',
							flexWrap: 'wrap',
							justifyContent: { lg: 'space-between', sm: 'start' },
							my: 1,
						}}
					>
						<Grid
							container
							rowSpacing={{ lg: 1, sm: 1 }}
							columnSpacing={{ lg: 2.5, sm: 2.5 }}
							sx={{
								display: 'flex',
								flexWrap: 'wrap',
								justifyContent: { lg: '', sm: 'start' },
								my: 0,
								'& .MuiTableRow': { padding: '16px' },
							}}
						>
							<MultiSelectInput
								name="parent_order_status"
								label="Parent Order Status"
								listItem={statusSelect}
								onChangeAdvancedForm={handleParentStatusChange}
								sx={{
									marginTop: { lg: 1, sm: 0.3 },
									height: { lg: 48, md: 41, sm: 35 },
									'& .MuiFormControl-root > .MuiInputBase-root': {
										height: { lg: 48, md: 41, sm: 35 },
									},
								}}
							/>

							<MultiSelectInput
								name="replace_order_status"
								label="Replace Order Status"
								listItem={statusSelect}
								onChangeAdvancedForm={handleReplaceStatusChange}
								sx={{
									marginTop: { lg: 1, sm: 0.3 },
									height: { lg: 48, md: 41, sm: 35 },
									'& .MuiFormControl-root > .MuiInputBase-root': {
										height: { lg: 48, md: 41, sm: 35 },
									},
								}}
							/>

							<InputForm
								name="parent_order_no"
								label="Parent Order No"
								advancedFormData={parentOrderNo}
								onChangeAdvancedForm={handleParentOrderChange}
							/>

							<InputForm
								name="replace_order_no"
								label="Replace Order No"
								advancedFormData={replaceOrderNo}
								onChangeAdvancedForm={handleReplaceOrderChange}
							/>
						</Grid>

						{/* Continue Button */}
						<Button
							variant="contained"
							onClick={handleContinue}
							sx={{ marginTop: 2 }}
							disabled={showLoader}
						>
							{showLoader ? 'Loading...' : 'Continue'}
						</Button>
					</Box>
				)}


				<SmartTable
					isSearch={false}
					isAdvancedFilter={false}
					isStatusMenu={false}
					isRowSelectable={false}
					refreshAction={false}
					showToolbar={false}
					originalRows={FilteredRows}
					defaultColumn={defaultColumn}
					totelItemCount={totalItemsCount}
					page={page}
					onExpandhandler={onExpandhandler}
					handleChangePage={handleChangePage}
					handleChangeRowsPerPage={handleChangeRowsPerPage}
					rowsPerPage={rowsPerPage}
					showLoader={showLoader}
					trackingPage={false}
					userSelectedColumns={userSelectedColumns}
					sortOrder={sortOrder}
					style={{ cursor: 'auto' }}
					rowHover={true}
					isDateRangePicker={false}
					showAdvancedFilter={false}
				/>
			</Container>
		</>
	);

}